import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { PlusOutlined } from '@ant-design/icons';
import * as S from './styles';

interface NewActionPlanProps {
	onClick(): void;
}

export function NewActionPlan({ onClick }: Readonly<NewActionPlanProps>) {
	return (
		<S.Container onClick={onClick}>
			<Row justify="center" align="middle" gutter={[0, 15]}>
				<Col span={24}>
					<Row justify="center">
						<S.IconWrapper span={10}>
							<PlusOutlined />
						</S.IconWrapper>
					</Row>
				</Col>
				<Col>
					<S.CustomText>{I18n.get('New action plan')}</S.CustomText>
				</Col>
			</Row>
		</S.Container>
	);
}
